import { t } from 'i18next';
import styled from 'styled-components';

import { Step, StepIndicator } from '#/components/StepIndicator/StepIndicator';
import { MEDIA_QUERIES } from '#/hooks';
import { remify } from '#/service/utils';

const StyledStepIndicator = styled(StepIndicator)`
  width: min(${remify(640)}, 100vw);
  margin-inline: 0;

  ${({ currentStep }) =>
    `margin-bottom: ${remify(currentStep === 1 ? 65 : 35)}`};

  @media ${MEDIA_QUERIES.xs} {
    margin-bottom: ${remify(25)};
  }
`;

export const SignupStepIndicator = ({
  currentStep,
}: {
  currentStep: number;
}) => (
  <StyledStepIndicator currentStep={currentStep}>
    <Step>{t('registration.pageTitle')}</Step>
    <Step>{t('iap.selectYourPlan')}</Step>
    <Step>{t('iap.setUpYourPayment')}</Step>
  </StyledStepIndicator>
);
